// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 164) return "js/inertia/164.js";
	if (chunkId === 57) return "js/inertia/57.js";
	// return url for filenames based on template
	return undefined;
};